import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class TelegramSettings extends Component {
  render() {
    return (
      <section>
        <p>Telegram</p>
      </section>
    );
  }
}

TelegramSettings.propTypes = {};

export default translate(TelegramSettings);
